export module MetricHelper {
  export const meterToFeet = (value: string) => {
    const res = Number(value)
    return (res * 3.281).toFixed(2)
  }
}
